module.exports = __webpack_public_path__ + "img/penn_state.273ca72e.jpg";